module.exports = __webpack_public_path__ + "static/img/CancelBtn.5822124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CancelBtn.png
// module id = cInq
// module chunks = 1